import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';


export default function LocatorMapListItem( props ) {
    const remains = props.data.amt - props.data.curPullSum;
    const daysOld = props.data.shipDateDays;

    return(

        <Paper elevation={3} sx={{p:1, mb:1}}>
            {props.data.curLat!=null && props.data.curLng!=null
            ?
                <Box>
                    <Box>
                        {props.data.curTrackerESN!=null
                        ?
                        <Box>
                            <Typography className="rtsTrackerMarker">{props.childIdx+1}</Typography>
                        </Box>
                        :
                        <Box>
                            <Typography className="rtsMarker">{props.childIdx+1}</Typography>
                        </Box>
                        }
                        <Box>
                            <Typography>{props.data.reelSerialNumber}</Typography>
                        </Box>
                        {props.data.curTrackerESN!=null
                        ?                        
                        <Box>
                            <Typography variant="caption">{props.data.curTrackerESN}</Typography>
                        </Box>
                        :
                        ""
                        }                        
                    </Box>
                    <Box sx={{display:'flex'}}>
                        <Typography variant="body2" sx={{fontWeight:'bold', pr:'2px'}}>Product:</Typography>
                        <Typography variant="body2">{props.data.curAliasName}</Typography>
                    </Box>
                    <Box sx={{display:'flex'}}>
                        <Typography variant="body2" sx={{fontWeight:'bold', pr:'2px'}}>Remaining:</Typography>
                        <Typography variant="body2">{remains.toLocaleString(undefined, { maximumFractionDigits: 2 })}</Typography>
                    </Box>
                    <Box sx={{display:'flex'}}>
                        <Typography variant="body2" sx={{fontWeight:'bold', pr:'2px'}}>Days Old:</Typography>
                        <Typography variant="body2">{daysOld.toLocaleString()}</Typography>
                    </Box> 
                </Box>
            :
                ""
            }
        </Paper>
    );
}
